import { render, staticRenderFns } from "./index.vue?vue&type=template&id=024db1ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandList: require('/opt/build/repo/components/brand/List.vue').default,SectionBase: require('/opt/build/repo/components/section/Base.vue').default})
